import React from 'react';

/**
 * HireHub Australia Official Logo Component
 * 
 * Usage:
 * - <HireHubLogo size="sm" /> - 32x32px (header icons)
 * - <HireHubLogo size="md" /> - 40x40px (default headers)
 * - <HireHubLogo size="lg" /> - 48x48px (auth pages)
 * - <HireHubLogo size="xl" /> - 64x64px (landing hero)
 * - <HireHubLogo showText={false} /> - Icon only
 * - <HireHubLogo textColor="white" /> - For dark backgrounds
 */

const sizeMap = {
  xs: { icon: 24, text: 'text-sm' },
  sm: { icon: 32, text: 'text-base' },
  md: { icon: 40, text: 'text-lg' },
  lg: { icon: 48, text: 'text-xl' },
  xl: { icon: 64, text: 'text-2xl' }
};

const HireHubLogo = ({ 
  size = 'md', 
  showText = true, 
  textColor = 'brand',
  className = '',
  iconOnly = false
}) => {
  const dimensions = sizeMap[size] || sizeMap.md;
  
  // Text color classes
  const textColorClass = textColor === 'white' 
    ? 'text-white' 
    : textColor === 'dark' 
      ? 'text-slate-900'
      : ''; // 'brand' uses the logo's natural colors

  if (iconOnly) {
    return (
      <img 
        src="/hirehub-logo.png" 
        alt="HireHub" 
        className={`object-contain ${className}`}
        style={{ 
          width: dimensions.icon, 
          height: dimensions.icon,
          objectPosition: 'center top'
        }}
      />
    );
  }

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <img 
        src="/hirehub-logo.png" 
        alt="HireHub Australia" 
        className="object-contain"
        style={{ 
          width: dimensions.icon, 
          height: dimensions.icon,
          objectPosition: 'center top'
        }}
      />
      {showText && (
        <span className={`font-heading font-bold ${dimensions.text} ${textColorClass}`}>
          {textColor === 'brand' ? (
            <>
              <span className="text-[#004B8D]">Hire</span>
              <span className="text-[#00A3BF]">Hub</span>
            </>
          ) : (
            'HireHub'
          )}
        </span>
      )}
    </div>
  );
};

// Simple icon-only version for compact spaces
export const HireHubIcon = ({ size = 32, className = '' }) => (
  <img 
    src="/hirehub-logo.png" 
    alt="HireHub" 
    className={`object-contain ${className}`}
    style={{ width: size, height: size, objectPosition: 'center top' }}
  />
);

export default HireHubLogo;
